import React from 'react';
import { Link } from 'react-router-dom';
import { Lock, ArrowLeft } from 'lucide-react';
type Step = 1 | 2 | 3;
interface LoginPayLayoutProps {
  currentStep: Step;
  showSuccess?: boolean;
  onBack?: () => void;
  /** When true, widens the main content area for dashboard-style layouts. */
  wide?: boolean;
  children: React.ReactNode;
}
const steps: {
  id: Step;
  label: string;
}[] = [{
  id: 1,
  label: 'Log In'
}, {
  id: 2,
  label: 'Choose Payment'
}, {
  id: 3,
  label: 'Confirm'
}];
export function LoginPayLayout({
  currentStep,
  showSuccess,
  onBack,
  wide = false,
  children
}: LoginPayLayoutProps) {
  const contentMax = wide ? 'max-w-5xl' : 'max-w-2xl';
  return <div className="min-h-screen bg-brand-gray flex flex-col font-sans" data-id="element-452">
      <header className="bg-white border-b border-gray-200" data-id="element-453">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-454">
          <Link to="/portal" className="flex items-center" aria-label="Back to portal home" data-id="element-455">
            <img src="https://cdn.magicpatterns.com/uploads/miiyVjkag3qKFYCybFaUjL/pasted-image.jpg" alt="Compass Recovery Group, LLC" className="h-9 w-auto object-contain" data-id="element-456" />
          </Link>
          <div className="flex items-center gap-2 text-xs font-medium text-brand-muted" data-id="element-457">
            <Lock size={14} className="text-green-600" data-id="element-458" />
            <span className="hidden sm:inline" data-id="element-459">Secure encrypted session</span>
            <span className="sm:hidden" data-id="element-460">Secure</span>
          </div>
        </div>
      </header>

      {!showSuccess && <div className="bg-white border-b border-gray-200" data-id="element-461">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-462">
            <ol className="flex items-center justify-between gap-2" data-id="element-463">
              {steps.map((step, index) => {
            const isComplete = currentStep > step.id;
            const isCurrent = currentStep === step.id;
            return <li key={step.id} className="flex items-center gap-2 flex-1 min-w-0" data-id="element-464">
                    <div className={`flex items-center gap-2 flex-shrink-0 ${isCurrent || isComplete ? '' : 'opacity-50'}`} data-id="element-465">
                      <div className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold transition-colors ${isComplete ? 'bg-brand-navy text-white' : isCurrent ? 'bg-brand-red text-white' : 'bg-gray-200 text-brand-muted'}`} aria-current={isCurrent ? 'step' : undefined} data-id="element-466">
                        {isComplete ? '✓' : step.id}
                      </div>
                      <span className={`text-sm font-semibold hidden sm:inline ${isCurrent ? 'text-brand-navy' : 'text-brand-muted'}`} data-id="element-467">
                        {step.label}
                      </span>
                    </div>
                    {index < steps.length - 1 && <div className={`flex-1 h-px ${currentStep > step.id ? 'bg-brand-navy' : 'bg-gray-200'}`} data-id="element-468" />}
                  </li>;
          })}
            </ol>
          </div>
        </div>}

      {onBack && !showSuccess && <div className={`${contentMax} mx-auto w-full px-4 sm:px-6 lg:px-8 pt-6`} data-id="element-469">
          <button onClick={onBack} className="inline-flex items-center gap-1 text-sm font-medium text-brand-muted hover:text-brand-navy transition-colors" data-id="element-470">
            <ArrowLeft size={16} data-id="element-471" />
            Back
          </button>
        </div>}

      <main className="flex-grow flex flex-col" data-id="element-472">
        <div className={`${contentMax} mx-auto w-full px-4 sm:px-6 lg:px-8 py-8 md:py-12 flex-grow`} data-id="element-473">
          {children}
        </div>
      </main>

      <footer className="border-t border-gray-200 bg-white py-4" data-id="element-474">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-xs text-brand-muted" data-id="element-475">
          This communication is from a debt collector. This is an attempt to
          collect a debt and any information obtained will be used for that
          purpose.
        </div>
      </footer>
    </div>;
}